import { useEffect, useMemo, useState } from 'react';

import { debounce } from 'lodash';
import { HeaderSearch } from 'twyne-new.ui';

import { useGrid } from '@Components/Grid/context';

export default function Search() {
  const [focused, setFocused] = useState(false)
  const { state: { setSearch, search } } = useGrid()
  const [localSearch, setLocalSearch] = useState(search || '')

  const debouncedSetSearch = useMemo(() => debounce(value => {
    setSearch(value)
  }, 500), [setSearch])

  useEffect(() => () => {
    debouncedSetSearch.cancel()
  }, [debouncedSetSearch])

  useEffect(() => {
    setLocalSearch(search || '')
  }, [search])

  const handleChange = value => {
    setLocalSearch(value)
    debouncedSetSearch(value)
  }

  return <>
    <HeaderSearch
      focused={focused || !!search}
      onFocus={setFocused}
      value={localSearch}
      onChange={handleChange}
      className='hidden md:flex'
    />

    <HeaderSearch
      focused={focused || !!search}
      onFocus={setFocused}
      value={localSearch}
      onChange={handleChange}
      className={`md:hidden w-auto min-w-0 basis-8 ${focused || search ? 'search-focused grow' : 'grow-0'}`}
      size='md'
    />
  </>
}

